import { createPortal } from 'react-dom';
import { useDevelopmentStatusStore } from '@/shared/store/developmentStatusStore';

/** 모달을 우선하고, 같은 범위에서는 마지막으로 등록한 문구만 표시한다. */
export default function DevelopmentStatusRibbon() {
  const label = useDevelopmentStatusStore((state) => {
    const entry = state.entries.findLast((item) => item.scope === 'modal') ?? state.entries.at(-1);
    return entry?.label;
  });

  if (!label) return null;

  return createPortal(
    <div
      role='status'
      aria-label={`개발 상태: ${label}`}
      className='pointer-events-none fixed bottom-[env(safe-area-inset-bottom,0px)] left-[env(safe-area-inset-left,0px)] z-[9998] size-40 overflow-hidden select-none'>
      <div className='absolute bottom-9 -left-10 flex h-9 w-56 rotate-45 items-center justify-center border-y border-amber-700/30 bg-amber-300 px-10 text-xs font-semibold text-amber-950 shadow-md'>
        <span className='truncate'>{label}</span>
      </div>
    </div>,
    document.body
  );
}
